import {
  Space,
  Row,
  Col,
  Button,
  Table,
  Typography,
  Divider,
  Popover,
  message,
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import "./Store.scss";
import {
  ButtonExcel,
  ColumnPopoverDisplay,
  ExpandSearch,
  ListActionButton,
} from "components/common";
import Icons from "assets/icons";
import {
  itemsInputField as inputFieldsInit,
  allColumns,
} from "./ListSupplies.config";

import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  exportFile,
  formatDateToString,
  isValuable,
  randomId,
} from "helper/common";
import {
  FORMAT_TIME,
  LOAI_FORM,
  // LOAI_PHIEU_KHO,
  LOAI_PHIEU_VTYT,
  // TT_PHIEU_KHO,
  TT_PHIEU_VTYT,
  tabKeys,
} from "types/enums";
import {components} from "./EditTable";
import {setActiveKey} from "redux/reducer/common";
import {
  getListSuppliesGroupAPI,
  getManufacturerAPI,
  getSupplierAPI,
  getSuppliesNameAPI,
  searchMedicalSuppliesAPI,
  setSelectedMedicalSupplies,
  setStatusPhieu,
  setTypeForm,
  setTypePhieu,
  updateDetailLo,
} from "redux/reducer/medicalSupplies";

import {NamePath} from "antd/es/form/interface";

import {RangePickerProps} from "antd/es/date-picker";
import Notification from "components/common/notification/notification";
import ButtonPdf from "components/common/ButtonPdf/ButtonPdf";
import ModalResults from "./ModalResults/ModalResults";

const ListSupplies = () => {
  const dispatch = useAppDispatch();
  const medicalSuppliesStore = useAppSelector(
    state => state.medicalSuppliesReducer
  );
  const [idLo, setIdLo] = useState(null);
  const [isShowModal, setIsShowModal] = useState(false);
  const listSuppliesRef = useRef<any>();
  const khoVTYTQuanLy = JSON.parse(localStorage.getItem("khoVTYTQuanLyLocal"));
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState<any>(
    allColumns.filter(e => e.show == true)
  );
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [fields, setFields] = useState<any[]>(inputFieldsInit);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 100,
  });

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(selectedRowKeys);
      dispatch(
        setSelectedMedicalSupplies(
          selectedRows.map(item => ({
            ...item,
            soLuong: item.xuatDuKien || null,
          }))
        )
      );
    },
    getCheckboxProps: (record: any) => ({
      disabled: !record["soLuongTon"] || record["soLuongTon"] <= 0, // Column configuration not to be checked
      name: record.name,
    }),
  };

  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = listSuppliesRef.current.getData()?.end;
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = listSuppliesRef.current.getData()?.start;
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find(e => e.name == "start").disabledDate =
      disabledDateStart;
    inputFieldsInit.find(e => e.name == "end").disabledDate = disabledDateEnd;
    setFields([...inputFieldsInit]);
  }, []);
  useEffect(() => {
    setData(
      medicalSuppliesStore.medicalSuppliesList.map(medicalSupplie => ({
        ...medicalSupplie,
        key: medicalSupplie.id,
        xuatDuKien: 0,
      }))
    );
  }, [medicalSuppliesStore.medicalSuppliesList]);
  useEffect(() => {
    allColumns.find(e => e.dataIndex == "action").render = (
      value,
      record,
      index
    ) => {
      return (
        <ListActionButton
          toolTipSave={"Cập nhật thông tin lô"}
          showDetailFunction={() => {
            setIsShowModal(true);
            setIdLo(record?.id);
          }}
          saveFunction={() => {
            const params = {
              id: record.id,
              donGiaXuat: record?.donGiaXuat,
              donGiaNhap: record?.donGiaNhap,
              note: record?.note,
            };
            dispatch(updateDetailLo(params));
            // call api luu thông tin lô
          }}
        ></ListActionButton>
      );
    };
    setColumns([...allColumns]);
  }, []);
  useEffect(() => {
    setColumns(
      columns
        .map(col => {
          if (!col.editable) {
            if (col.dataIndex === "index") {
              return {
                title: "STT",
                key: "index",
                show: true,
                dataIndex: "index",
                render(_: any, __: any, index: number) {
                  return <>{index + 1 + (params.page - 1) * params.limit}</>;
                },
                fixed: "left",
                width: 50,
                align: "center",
              };
            } else {
              return col;
            }
          }
          return {
            ...col,
            onCell: (record: any) => ({
              record,
              editable: true,
              dataIndex: col.dataIndex,
              title: col.title,
              type: col.type,
              handleSave,
            }),
          };
        })
        .filter(e => e.show == true)
    );
  }, [data]);
  useEffect(() => {
    dispatch(getSuppliesNameAPI());
    dispatch(getListSuppliesGroupAPI());
    dispatch(getSupplierAPI());
    dispatch(getManufacturerAPI());
  }, []);
  useEffect(() => {
    getListMedicineSupplies({
      storeId: khoVTYTQuanLy?.value,
      isEmpty: false,
      isSearchThau: true,
      ...params,
    });
  }, [params, khoVTYTQuanLy?.value]);

  useEffect(() => {
    if (inputFieldsInit.find(field => field.name === "VTYTName")) {
      inputFieldsInit.find(field => field.name === "VTYTName").options =
        medicalSuppliesStore.suppliesNameList.map(item => ({
          value: item.tenTheoThuongMai,
          label: item.tenTheoThuongMai,
          key: randomId(),
        }));
    }
  }, [medicalSuppliesStore.suppliesNameList]);

  useEffect(() => {
    setOptionsSearchFields(
      medicalSuppliesStore.suppliesGroupList,
      "nhomVTYTName"
    );
  }, [medicalSuppliesStore.suppliesGroupList]);

  useEffect(() => {
    inputFieldsInit.find(field => field.name === "storeId").options =
      medicalSuppliesStore.suppliesStoreList?.map(item => ({
        value: item.id,
        label: item.name,
        key: randomId(),
      }));
  }, [medicalSuppliesStore.suppliesStoreList]);

  useEffect(() => {
    setOptionsSearchFields(medicalSuppliesStore.supplierList, "nhaCungCapName");
  }, [medicalSuppliesStore.supplierList]);

  useEffect(() => {
    setOptionsSearchFields(
      medicalSuppliesStore.manufacturerList,
      "hangSanXuatName"
    );
  }, [medicalSuppliesStore.manufacturerList]);

  useEffect(() => {
    setOptionsSearchFields(
      medicalSuppliesStore.manufacturedCountryList,
      "nuocSanXuatName"
    );
  }, [medicalSuppliesStore.manufacturedCountryList]);

  const onChangePagination = (page: any, pageSize: any) => {
    setParams({...params, page: page, limit: pageSize});
    setLimit(pageSize);
    setPage(page);
  };
  const setOptionsSearchFields = (list: any[], name: NamePath) => {
    if (inputFieldsInit.find(field => field.name === name)) {
      inputFieldsInit.find(field => field.name === name).options = list?.map(
        (item: {name: any}) => ({
          value: item.name,
          label: item.name,
          key: randomId(),
        })
      );
    }
  };

  const setShowColumns = (showColumns: any) => {
    setColumns(showColumns);
  };
  const showModal = () => {
    setIsShowModal(true);
  };
  const handleCancel = () => {
    setIsShowModal(false);
  };
  const createExportForm = () => {
    if (medicalSuppliesStore.selectedMedicalSupplies.length) {
      dispatch(setActiveKey(tabKeys.MEDICAL_SUPPLIES_STORE.DETAIL));
      dispatch(setStatusPhieu(TT_PHIEU_VTYT.NHAP));
      dispatch(setTypeForm(LOAI_FORM.TAO_MOI));
      dispatch(setTypePhieu(LOAI_PHIEU_VTYT.XUAT));
    } else {
      Notification("warning", "Chưa chọn vật tư để tạo phiếu xuất");
    }
  };
  const onClickSearchMedicalSupplies = async () => {
    const searchFields = listSuppliesRef.current.getData();
    const searchMedicalSuppliesParams = {
      ...searchFields,
      start: formatDateToString(searchFields.start, FORMAT_TIME.dayFull),
      end: formatDateToString(searchFields.end, FORMAT_TIME.dayFull),
      page: 1,
    };

    setParams({
      ...params,
      ...searchMedicalSuppliesParams,
    });
  };
  const getListMedicineSupplies = async (params: any) => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(searchMedicalSuppliesAPI(params));
    setLoading(false);
  };

  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };
  const onKeyDown = (e: {key: string}) => {
    if (e.key === "Enter") {
      onClickSearchMedicalSupplies();
    }
  };
  const getReportFile = async () => {
    const params = {
      storeId: listSuppliesRef.current.getFieldValue("storeId"),
      isEmpty: null,
    };

    if (params?.storeId != null) {
      const tenKho = medicalSuppliesStore.suppliesStoreList.find(
        e => e.id == params?.storeId
      ).name;
      exportFile(
        "store/VTYT-store/export-ton-kho",
        params,
        `Báo cáo tồn kho - ${tenKho}`
      );
    } else {
      Notification("warning", "Chưa chọn kho để xuất báo cáo");
    }
  };
  const getReportFilePdf = async () => {
    const params = {
      storeId: listSuppliesRef.current.getFieldValue("storeId"),
      isEmpty: null,
    };

    if (params?.storeId != null) {
      const tenKho = medicalSuppliesStore.suppliesStoreList.find(
        e => e.id == params?.storeId
      ).name;
      exportFile(
        "store/VTYT-store/export-ton-kho-pdf",
        params,
        `Báo cáo tồn kho - ${tenKho}`,
        "pdf"
      );
    } else {
      Notification("warning", "Chưa chọn kho để xuất báo cáo");
    }
  };
  const getReportFileTheoVT = async () => {
    const params = {
      khoId: listSuppliesRef.current.getFieldValue("storeId"),
    };
    if (isValuable(params?.khoId)) {
      const tenKho = medicalSuppliesStore.suppliesStoreList?.find(
        e => e.id == params?.khoId
      )?.name;

      exportFile(
        "store/VTYT/export-danh-muc-vtyt",
        params,
        `Báo cáo tồn kho theo vật tư - ${tenKho}`
      );
    } else {
      Notification("warning", "Chưa chọn kho");
    }
  };
  return (
    <div className="medicine-container" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="container">
        {fields && (
          <ExpandSearch
            ref={listSuppliesRef}
            fields={fields}
            onClickSearch={onClickSearchMedicalSupplies}
            defaultFieldsValue={[
              {
                label: "storeId",
                value: khoVTYTQuanLy?.value,
              },
            ]}
            onReset={onClickSearchMedicalSupplies}
          />
        )}
      </div>
      <div className="container">
        <Space style={{width: "100%"}} direction="vertical">
          <Typography.Text strong>Danh sách vật tư</Typography.Text>
          <Divider type="horizontal" style={{margin: "0"}} />
          <Row justify={"space-between"} gutter={[16, 8]}>
            <Col>
              <Space>
                <ButtonExcel onClick={getReportFile} />
                <ButtonPdf onClick={getReportFilePdf}></ButtonPdf>
                <ButtonExcel
                  onClick={getReportFileTheoVT}
                  title="Báo cáo tồn kho theo vật tư"
                ></ButtonExcel>
              </Space>
            </Col>
            <Col>
              <Space style={{width: "100%"}}>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={allColumns}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button icon={<Icons.bars />} className="btn-sub">
                    Cột hiển thị
                  </Button>
                </Popover>

                <Button
                  icon={<Icons.file />}
                  className="btn-sub"
                  onClick={createExportForm}
                >
                  Tạo phiếu xuất
                </Button>
              </Space>
            </Col>
          </Row>
          {data && (
            <Table
              className="table-store"
              rowSelection={{
                type: "checkbox",
                ...rowSelection,
              }}
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
                total: medicalSuppliesStore.medicalSuppliesTotal,
                onChange: onChangePagination,
                pageSize: limit,
                current: page,
              }}
              components={components}
              columns={columns}
              dataSource={data}
              bordered={true}
              loading={loading}
              scroll={{x: 2000}}
            />
          )}
          <ModalResults
            idLo={idLo}
            isShowModal={isShowModal}
            handleOk={showModal}
            handleCancel={handleCancel}
          />
        </Space>
      </div>
    </div>
  );
};

export default ListSupplies;
